import React from 'react';
import logo from '../../assets/logo.svg';

function HeaderLogo() {
  return (
    <img src={logo} alt="" />
  )
};

export default HeaderLogo;

